<template>
  <div class="body">
    <div style="float: left;width: 49.5%;height: 800px;">
      <div class="boxs">
        <div class="title">
          通知公告
          <span style="float: right;">
            <el-button type="success" icon="el-icon-refresh-right" circle size="mini" @click="shuaxinpage"></el-button>
          </span>
        </div>
        <div>
          <hr color="#ddd">
        </div>
        <div class="content" v-loading="loading" element-loading-text="拼命加载中">
          <div class="flex" style="height: 735px;" v-if="a_noticelist.length<=0">
            暂无内容
          </div>
          <div style="width: 98%;" v-else>
            <!--重复阶段-->
            <div style="height: 700px;">
              <a href="javascript:;" @click="openInformation(data)" v-for="(data,index) in a_noticelist" :key="index">
                <div style="width: 100%;overflow: hidden;" id="notice">
                  <span style="float: left;margin-bottom: 5px;margin-top: 3px;margin-left: 0.5%;">
                    {{data.title}}
                    <span style="font-size: 5px;" v-if="PD_Notice_NEWOR(data.time)">
                      <em><strong><mark>New</mark></strong></em>
                    </span>
                    <span v-if="data.top_type=='1'"><el-tag size="mini" type="danger">置顶</el-tag></span>
                  </span>
                  <span style="float: right;margin-bottom: 5px;margin-top: 3px;margin-right: 1%;">
                    {{data.time*1 | formatDate}}
                  </span>
                </div>
              </a>
            </div>
            <div style="text-align: center;margin-top: 5px;">
              <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.pageNum"
                :page-size="formInline.pageSize" layout="total, prev, pager, next, jumper" :total="pageTotal">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="float: left;width: 49.5%;height: 800px;margin-left: 1%;">
      <div style="height: 49%;" class="boxs">
        <div class="title">
          微信公众号和小程序
        </div>
        <div>
          <hr color="#ddd">
        </div>
        <div class="content">
          <div class="flex" style="height: 325px;">
            <img src="@/assets/wxgzh.jpg" alt="" height="325px"><!--公众号-->
          </div>
        </div>
      </div>
      <div style="height: 48.5%;margin-top: 2%;" class="boxs">
        <div class="title">
          下载专区
        </div>
        <div>
          <hr color="#ddd">
        </div>
        <div class="content" v-loading="loading" element-loading-text="拼命加载中">
          <div class="flex" style="height: 315px;" v-if="downloadlist.length<=0">
            暂无内容
          </div>
          <div style="width: 98%;" v-else>
            <!--重复阶段-->
            <div style="height: 285px;">
              <a href="javascript:;" @click="downloadF(data)" v-for="(data,index) in downloadlist" :key="index">
                <div style="width: 100%;overflow: hidden;" id="notice">
                  <span style="float: left;margin-bottom: 5px;margin-top: 3px;margin-left: 0.5%;">
                    {{data.title}}
                  </span>
                  <span style="float: right;margin-bottom: 5px;margin-top: 3px;margin-right: 1%;">
                    {{data.time*1 | formatDate}}
                  </span>
                </div>
              </a>
            </div>
            <div style="text-align: center;margin-top: 5px;">
              <el-pagination background @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="formInline1.pageNum"
                :page-size="formInline1.pageSize" layout="total, prev, pager, next, jumper" :total="pageTotal1">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--管理员跳转按钮-->
    <!--
    <div v-if="AdminInfor.type*1<=1" :class="{on:AdminInfor.type*1<=1,off:AdminInfor.type*1>1,off:AdminInfor.type.length<=0}">
      <span style="float: right;margin-top: 15px;">
        <a href="javacript:;" style="color: #1fa1f1;" @click="gotothispage('/Aindex/report')">
          <i class="el-icon-s-data"></i>查看报表
        </a>
      </span>
    </div>
    -->

    <!--通知详情单-->
    <div class="Orderinfordiv" id="Noticeinformain">
      <NoticeInfors :data_id="data.id" div_name="Noticeinformain" div_content="aboutHtml_1"></NoticeInfors>
    </div>

  </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  import NoticeInfors from '@/admin/views/A_zujian/NoticeInfor.vue'//通知详情组件
export default {
  components: {
    'NoticeInfors': NoticeInfors,
  },
  data () {
    return {
      data:'',
      loading:false,
      formInline: {
        pageNum:1,
        pageSize:20
      },
      pageTotal:0,
      //
      formInline1: {
        pageNum:1,
        pageSize:10
      },
      pageTotal1:0,
      //通知信息
      a_noticelist:"",
      //
      downloadlist:'',
      //
      i:0,
      //管理员相关信息
      AdminInfor:{
        id:'',
        name:'',
        photo:'',
        type:'',
      },
    }
  },

  filters: {
        formatDate: function (value) {
          /*返回总体日期*/
          let date = new Date(value);
          let y = date.getFullYear();
          let MM = date.getMonth() + 1;
          MM = MM < 10 ? ('0' + MM) : MM;
          let d = date.getDate();
          d = d < 10 ? ('0' + d) : d;
          let h = date.getHours();
          h = h < 10 ? ('0' + h) : h;
          let m = date.getMinutes();
          m = m < 10 ? ('0' + m) : m;
          let s = date.getSeconds();
          s = s < 10 ? ('0' + s) : s;
          //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
          /*返回判断日期*/
          let timestamp = (new Date()).valueOf();
          let time=timestamp-value;//时间差
          let minute = 1000*60;
          let hour = minute * 60;
          var day = hour * 24;
          let times="";//内容
          let min = time/minute;//分钟
          let hours = time/hour;//天数
          return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
        }
      },

  //页面开启时执行
  mounted(){
    this.judgeLogin();
    this.getData()
    this.getData1()
  },
  //页面创建时进行
  created(){

  },
  //方法
  methods: {
    //刷新页面
    shuaxinpage(){
      this.judgeLogin();
      this.getData()
      this.getData1()
    },
    //判断是否为NEW
    PD_Notice_NEWOR(data){//data为传入时间参数
      let newdate=new Date().getTime();//获取当前时间
      let oneday=86400000;
      let time = newdate*1-data*1;
      if(time*1<=oneday*10){
        return true;
      }else{
        return false;
      }
    },
    //文件下载
    downloadF(item){
      const link = document.createElement('a')
      let name=item.title;
            link.setAttribute("download", name) //下载的文件名
            link.href = "/api"+item.content_url   //文件url
            link.click()
    },
    //打开通知详情
    openInformation(data){
      this.data="";
      this.data=data;
      sessionStorage.setItem("notice_infor_data",JSON.stringify(this.data));
      document.getElementById('Noticeinformain').style.display='block';
      document.getElementById('zhedang').style.display='block';
    },
    closeInformation(){
      this.data='';
      let dobj=document.getElementById("aboutHtml");
      dobj.innerHTML = '';
      document.getElementById('Noticeinformain').style.display='none';
      document.getElementById('zhedang').style.display='none';
    },
    //获取通知信息
    getData() {
      this.loading = true,
        commonAPI('queryA_noticelist',this.formInline).then(res => {
          this.loading = false;
          this.a_noticelist = res.data.data.rows;
          this.pageTotal=res.data.data.total;
          //console.log(res.data.rows);
        })
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.formInline.pageSize=val;
      this.formInline.pageNum=1;
      this.getData();
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.formInline.pageNum=val;
      this.getData();
    },
    //
    getData1() {
      this.loading = true,
        commonAPI('queryDownloadlist',this.formInline1).then(res => {
          this.loading = false;
          this.downloadlist = res.data.data.rows;
          this.pageTotal1=res.data.data.total;
          //console.log(res.data.rows);
        })
    },
    handleSizeChange1(val) {
      //console.log(`每页 ${val} 条`);
      this.formInline1.pageSize=val;
      this.formInline1.pageNum=1;
      this.getData1();
    },
    handleCurrentChange1(val) {
      //console.log(`当前页: ${val}`);
      this.formInline1.pageNum=val;
      this.getData1();
    },
    //获取信息方法
    judgeLogin(){
      setTimeout(() => {
        this.AdminInfor.id=this.$store.state.a_id;
        this.AdminInfor.type=this.$store.state.a_type;
        if(this.AdminInfor.type.length<=0){
          this.judgeLogin()
        }else{
          //console.log(this.i)
        }
      },500)
    },
    //更换页签
    gotothispage(data){
      this.$router.push({path: data});
    },
  }
}
</script>

<style scoped>
  .body{
    min-width: 1180px;
    height: 100%;
  }
  .boxs{
    height: 100%;
    border-radius: 10px;
    border: 1px solid #ddd;
  }
  .title{
    margin: 10px 10px;color: #1fa1f1;font-size: 18px;
  }
  .content{
    margin: 10px 10px;font-size: 16px;width: 100%;overflow: hidden;
  }
  .content a{
    color: #000;
  }
  .content a:hover{
    color: #fff;
  }
  .flex{
    color: #aaa;
    /*flex 布局*/
    display: flex;
    /*实现垂直居中*/
    align-items: center;
    /*实现水平居中*/
    justify-content: center;
    text-align: justify;
  }
  .on{
    width: 100%;
  }
  .off{
    width: 100%;display: none;
  }
  #notice:hover{
    background-color: #c5c5c5;
  }
  /**Orderinfor框架*/
  .Orderinfordiv{
    position: fixed;
    top: 13%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    display: none;
  }
  .OrderinforForm{
    margin: 0 auto;
    width: 900px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .OrderinforForm a{
    color: #fff;
  }
  .OrderinforForm a:hover{
    color: #d6d6d6;
  }
  .playlistbox_botton{
     width: 900px;margin: 0 auto;
     overflow: hidden;
     height: 633px;
     overflow-y: scroll;
   }
   /**滚动条样式*/
   .playlistbox_botton::-webkit-scrollbar{
     width: 5px;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     border-radius: 10px;
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     background: #535353;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     border-radius: 10px;
     background: #EDEDED;
   }
   /**！Orderinfor框架*/
</style>



// WEBPACK FOOTER //
// src/admin/views/index/Text.vue